import { render, staticRenderFns } from "./AskSkeletonLoader.vue?vue&type=template&id=3b77092e&scoped=true&"
import script from "./AskSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./AskSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./AskSkeletonLoader.vue?vue&type=style&index=0&id=3b77092e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b77092e",
  null
  
)

export default component.exports